import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Users, Star, Download, Target } from 'lucide-react';
import { PriceCta } from './ui/PriceCta';
export function Hero() {
  return <section className="pt-24 pb-16 md:pt-32 md:pb-24 px-6 border-b border-ink/10" data-id="element-81">
      <div className="max-w-editorial mx-auto" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl" data-id="element-83">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-ink leading-[1.1] mb-8" data-id="element-84">
            La Ansiedad Es Tu Síntoma,
            <br className="hidden md:block" data-id="element-85" /> No Tu Identidad
          </h1>

          <p className="text-xl md:text-2xl text-ink-light font-sans leading-relaxed mb-10 max-w-3xl" data-id="element-86">
            Tu mente bajo control en un fin de semana: el método definitivo para
            desmantelar el caos mental, recuperar la disciplina emocional y
            apagar el piloto automático. Sin fármacos. Sin procesos eternos.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-87">
            <div className="flex items-center gap-2 bg-bone-dark px-4 py-2 rounded-sm text-sm font-medium text-ink" data-id="element-88">
              <Download size={16} className="text-oxblood" data-id="element-89" />
              <span data-id="element-90">PDF Digital — Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2 bg-bone-dark px-4 py-2 rounded-sm text-sm font-medium text-ink" data-id="element-91">
              <Target size={16} className="text-oxblood" data-id="element-92" />
              <span data-id="element-93">Nivel: Para quienes sienten que la cabeza no frena</span>
            </div>
          </div>

          <div className="mb-8 max-w-md" data-id="element-94">
            <PriceCta variant="light" data-id="element-95" />
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-ink-light" data-id="element-96">
            <div className="flex items-center gap-1.5" data-id="element-97">
              <ShieldCheck size={16} className="text-sage" data-id="element-98" />
              <span data-id="element-99">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-100">
              <CreditCard size={16} className="text-sage" data-id="element-101" />
              <span data-id="element-102">Mercado Pago disponible</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-103">
              <Users size={16} className="text-sage" data-id="element-104" />
              <span data-id="element-105">Más de 500 personas ya recuperaron el control</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-106">
              <Star size={16} className="text-oxblood fill-oxblood" data-id="element-107" />
              <span data-id="element-108">4.9/5 de Calificación</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}